module.exports = __webpack_public_path__ + "static/media/icon_inactive.7226ae4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon_inactive.png
// module id = 3777
// module chunks = 0